import { SettingsFormValues } from '../../../Elements/SystemSettings/Battery/types'
import { BatteryModel } from 'src/Libs/batteries'
import { boolean, object } from 'yup'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { fromModelToFormModelTransformer } from 'src/Libs/batteries/transformers'
import { FormInitializerReturnType, numberSchema } from 'src/Configuration/validation'

/**
 * Initializes the form for battery settings
 * @param model - BatteryModel
 * @returns initialValues and validationSchema for battery settings form
 */
export const useBatterySettingsFormInitializer = (model: BatteryModel): FormInitializerReturnType<SettingsFormValues, SettingsFormValues> => {
  const { t } = useCustomTranslation()
  const initialValues = fromModelToFormModelTransformer(model)
  const numberSchemaWithTranslation = numberSchema(t)
  const validationSchema = object({
    isAdjustmentEnabled: boolean().required(),
    voltage: numberSchemaWithTranslation({ min: model.voltageAdjustment.min, max: model.voltageAdjustment.max }).required(),
  })
  return { initialValues, validationSchema }
}
